import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

/** This state should only occur in app on versions prior to 13.8 */
export const AccountAlreadyDeleted = () => {
    const { t } = useTranslation();

    return (
        <div className={styles["account-already-deleted-container"]}>
            <h5>{t("account-delete:all-set")}</h5>
            <p>{t("account-delete:deleted-subtext")}</p>
            <p>{t("account-delete:thanks")}</p>
        </div>
    );
};
